import { createFileRoute } from '@tanstack/react-router';
import { type FormEvent, useState } from 'react';
import { useArchiveLabel, useCreateLabel, useLabels } from '#features/labels/api';
import { Button } from '#components/ui/button';
import { useCanWrite } from '#lib/auth/vitto-session';

const LabelsSettings = () => {
  const labels = useLabels();
  const create = useCreateLabel();
  const archive = useArchiveLabel();
  const canWrite = useCanWrite();
  const [name, setName] = useState('');

  const submit = (event: FormEvent): void => {
    event.preventDefault();
    if (name.trim() === '') return;
    // El color de una etiqueta es un dato del dominio que se guarda en la base, no un
    // token de la interfaz. design-tokens-ignore color-literal
    create.mutate({ name: name.trim(), color: '#64748b' }, { onSuccess: () => setName('') });
  };

  const active = (labels.data ?? []).filter((label) => label.archivedAt === null);

  return (
    <main className="mx-auto max-w-2xl p-8">
      <h1 className="mb-4 text-2xl">Labels</h1>
      {canWrite ? (
        <form onSubmit={submit} className="mb-6 flex gap-2">
          <input
            aria-label="Label name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            className="flex-1 rounded-sm border border-input px-2 py-1 text-sm bg-background"
          />
          <Button type="submit" size="sm">
            Create
          </Button>
        </form>
      ) : null}
      <ul className="divide-y divide-border">
        {active.map((label) => (
          <li key={label.id} className="flex items-center justify-between py-2 text-sm">
            <span className="flex items-center gap-2">
              <span
                aria-hidden="true"
                className="size-2.5 rounded-full"
                style={{ backgroundColor: label.color }}
              />
              {label.name}
            </span>
            {/* Archivar, nunca borrar: el historial de los items debe seguir siendo legible. */}
            {canWrite ? (
              <button
                type="button"
                onClick={() => archive.mutate(label.id)}
                className="text-link underline"
              >
                Archive
              </button>
            ) : null}
          </li>
        ))}
        {active.length === 0 ? (
          <li className="py-2 text-sm text-muted-foreground">No labels yet.</li>
        ) : null}
      </ul>
    </main>
  );
};

export const Route = createFileRoute('/_authed/settings/labels')({ component: LabelsSettings });
